module.exports = __webpack_public_path__ + "img/14.9bf89df5.jpg";